module.exports = __webpack_public_path__ + "static/img/CN.26187a64.svg";